import React from 'react'

export default function ResinousCoveCoverageDetailsModals(props) {
   const {
      availableColors,
      availableChipColors,
      setChipValue,
      setColorValue,
      setStateChipValue,
      setStateColorValue,
      setColorImage,
       setChipImage,
       setColorSku,
       setColorChipSku,
       setColorCoverage,
       setColorChipCoverage
   } = props

    function handleColorSelect(colorName, colorImage, colorSku, colorCoverage) {
      setColorValue(colorName)
      setStateColorValue(colorName)
       setColorImage(colorImage)
       setColorSku(colorSku)
       setColorCoverage(colorCoverage)
   }
    function handleChipSelect(chipName, chipImage, colorChipSku, colorChipCoverage) {
        console.log(colorChipSku)
      setChipValue(chipName)
      setStateChipValue(chipName)
        setChipImage(chipImage)
        setColorChipSku(colorChipSku)
        setColorChipCoverage(colorChipCoverage)
   }

   return (
      <React.Fragment>
         <div className="modal fade" id="availableResinousChips" tabIndex="-1" role="dialog" aria-labelledby="availableResinousChipsLabel" aria-hidden="true">
            <div className="modal-dialog modal-chip-and-color" role="document">
               <div className="modal-content">
                  <div className="modal-header">
                     <h3 className="modal-title" id="availableResinousChips">Select Quartz</h3>
                     <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                     </button>
                  </div>
                  <div className="modal-body">
                     <div className="row p-1">
                     {
                        // Create an option for each available chip color.
                        availableChipColors.map((chip, index) => {
                           const chipName = chip.Name
                           return (
                              <div className="col-xs-6 col-sm-3 swatch" key={ chip.Sku+"_"+index }>
                                 <img
                                    alt={ chip.Name }
                                    src={ chip.ColorOrChipImage ? "https://cdn.laticrete.com/" + chip.ColorOrChipImage : "http://via.placeholder.com/737x737" }
                                    className="img-responsive"
                                    data-bs-dismiss="modal"
                                       onClick={() => handleChipSelect(chip.Name, chip.ColorOrChipImage, chip.Sku, chip.Coverage) }
                                 />
                                 <h4>{ chipName }</h4>
                              </div>
                           )
                        })
                     }
                     </div>
                  </div>
                  <div className="modal-footer">
                     <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                  </div>
               </div>
            </div>
         </div>
         <div className="modal fade" id="availableResinousColors" tabIndex="-1" role="dialog" aria-labelledby="availableResinousColorsLabel" aria-hidden="true">
            <div className="modal-dialog modal-chip-and-color" role="document">
               <div className="modal-content">
                  <div className="modal-header">
                     <h3 className="modal-title" id="availableResinousColors">Select Color</h3>
                     <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                     </button>
                  </div>
                  <div className="modal-body">
                     <div className="row p-1">
                     {
                        // Create an option for each available color.
                        availableColors.map(color => {
                           const colorName = color.Name
                           return (
                              <div className="col-xs-6 col-sm-3 swatch" key={ color.Sku }>
                                 <img
                                    alt={ color.Name }
                                    src={ color.ColorOrChipImage ? "https://cdn.laticrete.com/" + color.ColorOrChipImage : "http://via.placeholder.com/737x737" }
                                    className="img-responsive"
                                    data-bs-dismiss="modal"
                                       onClick={() => handleColorSelect(colorName, color.ColorOrChipImage, color.Sku, color.Coverage) }
                                 />
                                 {
                                 // .replace(REGEX) removes parentheses within color.Name
                                 }
                                 <h4>{ colorName }</h4>
                              </div>
                           )
                        })
                     }
                     </div>
                  </div>
                  <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                  </div>
               </div>
            </div>
         </div>


         
         <div className="modal fade" id="modal-height" tabIndex="-1" role="dialog" aria-labelledby="modal-height" aria-hidden="true">
            <div className="modal-dialog" role="document">
               <div className="modal-content">
                  <div className="modal-header">
                     <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                     </button>
                     <h3 className="modal-title">Select Height</h3>
                  </div>
                  <div className="modal-body">
                     <div className="row p-1">
                        <div className="col-xs-12">
                           <p>Resinous coves are either 4" or 6" in height from their base. Height affects the coverage amount of products used in the resinous system.</p>
                           <a href="# " className="btn btn-primary" data-bs-dismiss="modal">CLOSE</a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </React.Fragment>
   )
}



// WEBPACK FOOTER //
// ./src/components/productTypes/resinous/ResinousCoveCoverageDetailsModals.js